import React, { Component, } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { updatePropertyInput } from '../PropertyActions';
import { PurchaseWizardPage } from './PurchaseWizardPage';
import { MonthlyWizardPage } from './MonthlyWizardPage';
import { GoalsWizardPage } from './GoalsAndIncomeWizardPage';
import WizardStepNavigation from './WizardStepNavigation';

class Questions extends Component {
    displayName = Questions.name

    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        // Extract the name of the input and it's value from the DOM event
        const target = event.target;
        var value = target.type === 'text' || target.type === 'select-one' ? target.value : parseFloat(target.value);
        const name = target.name;

        // dispatches actions to update value
        this.props.updatePropertyInput(name, value);
    }

    wizardSteps() {
        const values = this.props;

        return [
            <PurchaseWizardPage values={values} onChangeHandler={this.handleInputChange} />,
            <MonthlyWizardPage values={values} onChangeHandler={this.handleInputChange} />,
            <GoalsWizardPage values={values} onChangeHandler={this.handleInputChange} />
        ];

    }
    
    render() {
        return (
            <Row>
                <Col xs="12" lg={{ size: 6, offset: 3 }}>
                    <div className="wizard-container">
                        <div className="wizard">
                            {this.wizardSteps()[this.props.currentWizardStepIndex]}
                        </div>
                        <WizardStepNavigation numberOfSteps={this.wizardSteps().length} />
                    </div>  
                </Col>
            </Row>
        );
    }
}
    
    
const mapStateToProps = state => {
    return state.property;
};

export default connect(
    mapStateToProps,
    { updatePropertyInput }
)(Questions);


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/Questions.jsx